import type { HeldOrder } from '../types/heldOrder';

const STORAGE_KEY = 'pos-held-orders';
const DEFAULT_MAX_AGE_MS = 8 * 60 * 60 * 1000; // 8 hours

function readAll(): HeldOrder[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeAll(orders: HeldOrder[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(orders));
}

function purgeExpired(maxAgeMs: number = DEFAULT_MAX_AGE_MS): void {
  const now = Date.now();
  const orders = readAll();
  const valid = orders.filter(o => now - o.createdAt < maxAgeMs);
  if (valid.length !== orders.length) {
    writeAll(valid);
  }
}

export function getHeldOrders(vendorId: number): HeldOrder[] {
  purgeExpired();
  return readAll().filter(o => o.vendorId === vendorId);
}

export function saveHeldOrder(order: HeldOrder): void {
  purgeExpired();
  const orders = readAll();
  orders.push(order);
  writeAll(orders);
}

export function deleteHeldOrder(id: string): void {
  const orders = readAll().filter(o => o.id !== id);
  writeAll(orders);
}

export function getHeldOrdersForTable(vendorId: number, tableId: number): HeldOrder[] {
  return getHeldOrders(vendorId).filter(o => o.tableId === tableId);
}
